import React from 'react';
import { LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import { DischargeDueListItem } from 'MessageCenter/DischargeDue'
import styles from './List.module.css'

class DischargeDueList extends React.Component {

    render() {
        return (
            <div>
                {this.props.loading &&
                    <div className={styles.loading_container}>
                        <LoadingIcon size="small" />
                    </div>
                }
                <ScrollDiv divId={'MC_DC_DUE'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .sort((a, b) => new Date(this.props.messages[b].lastSeen) - new Date(this.props.messages[a].lastSeen))
                        .map(key => {
                            const message = this.props.messages[key];
                            return <DischargeDueListItem
                                key={message.epno}
                                id={message.epno}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let messages = Object.keys(state.entities.dcDue)
        .sort((a, b) =>
            new Date(state.entities.dcDue[a].lastSeen).getTime() - new Date(state.entities.dcDue[b].lastSeen).getTime()
        )
        .map(x => state.entities.dcDue[x]);


    return {
        messages,
        loading: state.ui.dcDue.loading
    };
}

const connectedDischargeDueList = connect(mapStateToProps)(DischargeDueList);
export { connectedDischargeDueList as DischargeDueList };